import { useAppParameters } from "@/hooks/useAppParameters";
import { useAuth } from "@/hooks/useAuth";

export const useContainer = () => {
  const { isApp } = useAppParameters();
  const { user: authUser, tellerUser, isVipUser, isOfficialWriter } = useAuth();

  return {
    isApp,
    authUser,
    tellerUser,
    isVipUser,
    isOfficialWriter,
  };
};
